import React from 'react';
import { connect } from 'react-redux';
import {logOutPassenger} from './../../actions/authenticationActions';
import {clearLocalStorageOnLogout, getPostLogoutUrl} from "../../utils/configUtils";
import { navigate } from '../../utils/navigationUtils';

class PassengerLogout extends React.Component {

    componentDidMount() {
        const tradePortalLogoutUrl = this.props.tradePortalLogoutUrl;
        logOutPassenger(clearLocalStorageOnLogout()).then(() => {
            const redirectUrl = getPostLogoutUrl(tradePortalLogoutUrl);


            if(redirectUrl.startsWith("http")) {
                window.location.href = redirectUrl;
            }
            else {
                navigate(redirectUrl);
            }
        });
    }

    render() {
        return null;
    }
}

function mapStateToProps(state) {
    return {
        tradePortalLogoutUrl: state.authentication?.tradeportal?.logoutUrl,
    };
}

export default connect(mapStateToProps)(PassengerLogout);